import React, { useContext, useEffect, useState } from "react"
import { createPortal } from "react-dom"
import styles from "./AnnotationModal.module.css"
import { StepContext } from "../../StepContainer"
import { useAbTestGtm } from "../../../../../hooks/useAbTestGtm"

interface AnnotationModalProps {
    isOpen: boolean
    onClose: () => void
}

/**
 * 本応募完了後の連絡についての注釈モーダル。ページ表示時に自動で開く
 *
 * @param isOpen モーダルの開閉状態
 * @param onClose モーダルを閉じる際に呼ばれるコールバック
 */
export const AnnotationModal: React.FC<AnnotationModalProps> = ({
    isOpen,
    onClose,
}) => {
    const { offerInfo } = useContext(StepContext)
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
        return () => setMounted(false)
    }, [])

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : ""
        return () => {
            document.body.style.overflow = ""
        }
    }, [isOpen])

    if (!isOpen || !mounted) return null

    const modalContent = (
        <div
            className={styles.overlay}
            role="dialog"
            aria-modal="true"
            data-view-label={dataViewLabel("EF_StepForm_応募POP")}
        >
            <div className={styles.modal}>
                <div className={styles.notice}>
                    <div className={styles.noticeRow}>
                        <img
                            src="/foodslaboEf/img/common/b/warning-circle.svg"
                            alt=""
                            className={styles.noticeIcon}
                        />
                        <p className={styles.noticeText}>
                            現在仮応募中です。本応募完了後、企業やり取りが開始されます。選考結果はメール/SMS/サイト内メッセージで届きます
                        </p>
                    </div>

                    {offerInfo && (
                        <div className={styles.offerCard}>
                            <p className={styles.offerTitle}>
                                {offerInfo.occupationName}の求人
                            </p>
                            <p className={styles.offerShopName}>
                                {offerInfo.shopName}
                            </p>
                            <div className={styles.offerAddressRow}>
                                <img
                                    src="/client/img/icon/map.svg"
                                    alt=""
                                    className={styles.mapIcon}
                                />
                                <span className={styles.offerAddress}>
                                    {offerInfo.address}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                {/* このボタンはモーダルを閉じるだけで、実際の応募進行は下の在職/離職選択で行う */}
                <button
                    className={styles.nextButton}
                    onClick={onClose}
                    data-click-label={dataClickLabel(
                        "EF_StepForm_応募POP-本応募へ進む"
                    )}
                >
                    本応募へ進む（約1分）
                    <img
                        src="/foodslaboEf/img/common/nextIcon.svg"
                        alt=""
                        className={styles.nextIcon}
                    />
                </button>
            </div>
        </div>
    )

    return createPortal(modalContent, document.body)
}
